export type RecordingMetadata = {
  replayId: string;
  time: number;
  distinctId: string;
  name: string;
  avatarUrl: string;
  email: string;
  duration: number;
  replayEvents?: RecordingEventMetadata[];
};

export type RecordingEventMetadata = {
  eventName: string;
  eventTime: number;
  quantity: number;
};

export enum RecordingPlayerTrackingEvent {
  Watch = `[Recording Player] Replay Watched`,
  Finish = `[Recording Player] Replay Finished`,
  Close = `[Recording Player] Modal Closed`,
  Open = `[Recording Player] Modal Opened`,
  Feedback = `[Recording Player] Feedback Submitted`,
  ListLoaded = `[Recording Player] Replay List Loaded`,
  ListLoadFailed = `[Recording Player] Replay List Load Failed`,
}

export enum RecordingPlayerSource {
  UsersProfile = `User Profile`,
  UsersProfileLink = `User Profile Link`,
  Funnels = `Funnels`,
  Event = `Event`,
}
